import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-4333000c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "tSASetupModal",
  class: "modal fade tsa-setup-modal tw-block",
  role: "dialog",
  "aria-labelledby": "tSASetupModalLabel",
  "data-backdrop": "false"
}
const _hoisted_2 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "modal-body account-modal" }
const _hoisted_7 = { class: "modal-body-sec1" }
const _hoisted_8 = { class: "auth-modal-text" }
const _hoisted_9 = { class: "qr-code" }
const _hoisted_10 = { class: "qr-code-image" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "qr-code-text" }
const _hoisted_13 = { class: "helper-text" }
const _hoisted_14 = {
  class: "token",
  "data-cy": "twoStepAuthenticationSetup-secretToken"
}
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = {
  for: "id",
  class: "control-label input-label-form"
}
const _hoisted_17 = { class: "letsgo-btn" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = { class: "modal-footer" }
const _hoisted_20 = { class: "modal-footer-sec1" }

import $ from "jquery";
import userService from "@/services/user/userService";
import errorhandler from "@/components/common/exceptionHandler.vue";
import Utils from "@/utils/utilities";
import { load } from "recaptcha-v3";
import store from "@/store";
import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";
import router from "@/router";
import { localStorageBoolean, localStorageKey } from "@/utils/constants";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { showErrorAPI } from "@/services/apiRoutes";


export default /*#__PURE__*/_defineComponent({
  __name: 'tsaSetupContain',
  setup(__props) {

const imgSrc = ref("");
const authCode = ref("");
const isCodeValid = ref(false);
const totpValid = ref(true);
const secretToken = ref("");

const showProspectCallbackError = ref(false);
const prospectCallbackErrorMsg = ref("");

const languageSelected = computed(
  () => store.state.LanguagePicker.languageSelected,
);
const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);

const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const checkIsTokenValid = (e) => {
  if (e.target.value && e.target.value.length > 1 && isNaN(e.target.value)) {
    totpValid.value = false;
  } else {
    totpValid.value = true;
  }
  if (e.target.value && e.target.value.length >= 6 && !isNaN(e.target.value)) {
    isCodeValid.value = true;
  } else {
    isCodeValid.value = false;
  }
};

const getSetupInfo = async () => {
  try {
    await userService.getMFASetupInfo().then(
      (res: any) => {
        if (res?.data?.data && res?.data?.data?.dataURL) {
          imgSrc.value = res.data.data.dataURL;
          secretToken.value = res.data.data.tempSecret;
        }
      },
      (error: any) => {
        if (error && error.data && error.data.error && error.data.error.type) {
          if (error.data.error.type === "exc_session_invalid-1") {
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data.error),
            );
            router.push({ path: "/" });
          } else {
            showErrorInfo(error.data.error);
          }
        } else {
          showErrorInfo(error.data);
        }
      },
    );
  } catch (error) {
    return error;
  }
};

const showErrorInfo = (errorInfo: any) => {
  if (errorInfo && errorInfo !== "") {
    errorInfo =
      typeof errorInfo === "string" ? JSON.parse(errorInfo) : errorInfo;
    if (errorInfo && Object.keys(errorInfo).length > 0 && errorInfo.message) {
      showProspectCallbackError.value = true;
      prospectCallbackErrorMsg.value = errorInfo.message;
    }
  }
};

const showToastError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const authcodeInput: any = ref();
const onResize = () => {
  authcodeInput.value && authcodeInput.value.focus();
};

const setLanguages = async () => {
  await Utils.getV3Recaptcha().then(
    async (finalKey: any) => {
      localStorage.removeItem("csrfReloadDone");
      const captchKey = finalKey;
      const recaptcha = await load(`${captchKey}`, {
        autoHideBadge: true,
      });
      recaptcha.execute("submit").then((token) => {
        localStorage.setItem(localStorageKey.recaptcha, token);
        store.dispatch("LanguagePicker/setLanguages", token);
      });
      recaptcha.execute("submit").then((token) => {
        localStorage.setItem(localStorageKey.recaptcha, token);
        store.dispatch("LanguagePicker/setLanguageList", token);
      });
    },
    (error: any) => {
      if (error && error.data && error.data.error && error.data.error.type) {
        if (error.data.error.type === "exc_session_invalid-1") {
          sessionStorage.setItem(
            "prospectCallbackErrorInfo",
            JSON.stringify(error.data.error),
          );
          router.push({ path: "/" });
        } else {
          showErrorInfo(error.data.error);
        }
      } else if (error.data.message === "invalid csrf token") {
        if (localStorage.getItem("csrfReloadDone") == null) {
          localStorage.setItem("csrfReloadDone", localStorageBoolean.true);
          router.go(0);
        }
        sessionStorage.setItem(
          "prospectCallbackErrorInfo",
          JSON.stringify(error.data),
        );
        router.push({ path: "/" });
      } else {
        showErrorInfo(error.data);
      }
    },
  );
};

onMounted(() => {
  getSetupInfo();
  nextTick(function () {
    window.addEventListener("resize", onResize);
    onResize();
  });

  document.getElementById("tSASetupModal")?.classList.add("show");

  if (!$("body").hasClass("page-opacity")) {
    $("body").addClass("page-opacity page-bg");
  }

  setLanguages();
});

const getUiText = (id: string, isArray = false) => {
  return Utils.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const submit = () => {
  if (authCode.value && totpValid.value) {
    userService.confirmMFAToken({ token: authCode.value }).then(
      async (res: any) => {
        if (res?.data?.message) {
          await Utils.afterLoginActions(res.data.data);
        }
      },
      (error: any) => {
        if (error?.data?.error?.type) {
          if (error.data.error.type === "exc_session_invalid-1") {
            sessionStorage.setItem(
              "prospectCallbackErrorInfo",
              JSON.stringify(error.data.error),
            );
            router.push({ path: "/" });
          } else if (error.data.error.type === "exc_user_auth_locked_out") {
            const message = getUiText("app-api-user-mfa-verify-error-1");
            showToastError(message);
          } else {
            if (error.data.error.type === "exc_user_mfa_enable_fail-1") {
              showToastError(
                getUiText("app-api-user-mfa-verify-fail-experied-1"),
              );
              return;
            }
            if (
              error.data.error.type === "exc_invalid_parameters-1" &&
              error.data.error.id === "token"
            ) {
              showToastError(
                getUiText("app-api-user-mfa-verify-invalid-param-1"),
              );
              return;
            }
            showErrorAPI(error, "error");
          }
        } else {
          showErrorAPI(error, "error");
        }
      },
    );
  }
};

const resetShowProspectCallbackError = () => {
  showProspectCallbackError.value = false;
  prospectCallbackErrorMsg.value = "";
};

const onClickClose = () => {
  router.go(-1);
};

onBeforeUnmount(() => {
  if ($("body").hasClass("page-opacity")) {
    $("body").removeClass("page-opacity page-bg page-shadow");
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showProspectCallbackError.value || null)
      ? (_openBlock(), _createBlock(errorhandler, {
          key: 0,
          "prospect-callback-error-msg": prospectCallbackErrorMsg.value,
          onResetShowProspectCallbackError: resetShowProspectCallbackError
        }, null, 8, ["prospect-callback-error-msg"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("button", {
              type: "button",
              class: "close",
              "aria-label": "Close",
              onClick: onClickClose
            }, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", null, _toDisplayString(getUiText("user-mfa-register-heading-1")), 1)
            ]),
            _createElementVNode("div", _hoisted_8, _toDisplayString(getUiText("user-mfa-register-heading-sub-1")), 1),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("img", { src: imgSrc.value }, null, 8, _hoisted_11)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(getUiText("user-mfa-register-qr-prompt-1")), 1),
                  _createElementVNode("div", _hoisted_14, _toDisplayString(secretToken.value), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("form", null, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(getUiText("user-mfa-register-enter-code-heading-1")), 1),
                _withDirectives(_createElementVNode("input", {
                  ref_key: "authcodeInput",
                  ref: authcodeInput,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((authCode).value = $event)),
                  "data-cy": "twoStepAuthenticationSetup-authCode",
                  type: "text",
                  class: _normalizeClass(`form-control form-control-lg authcode-input ${
                  !totpValid.value ? 'invalid-input' : ''
                }`),
                  tabindex: "0",
                  onInput: checkIsTokenValid
                }, null, 34), [
                  [_vModelText, authCode.value]
                ]),
                (!totpValid.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["error-msg", !totpValid.value ? 'mg-top-19' : ''])
                    }, [
                      _createElementVNode("span", null, _toDisplayString(getUiText("user-mfa-setup-error-valid-1")), 1)
                    ], 2))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("button", {
                type: "button",
                "data-cy": "twoStepAuthenticationSetup-submit",
                class: "btn btn-primary letsgo-button",
                disabled: isCodeValid.value ? false : true,
                onClick: submit
              }, _toDisplayString(getUiText("user-mfa-register-button-lets-go-1")), 9, _hoisted_18)
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, _toDisplayString(getUiText("user-mfa-register-footer-text-1")), 1)
          ])
        ])
      ])
    ])
  ], 64))
}
}

})